import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'

import { useLocalRecording } from '@/react-query/local-recording'

import { useAudioRecorder } from '../../../../context/AudioRecorderContext/AudioRecorderContext'

interface DiscardConfirmationModalProps {
  isOpen: boolean
  onClose: () => void
}

export const DiscardConfirmationModal = ({
  isOpen,
  onClose,
}: DiscardConfirmationModalProps) => {
  const { discardExistingRecording } = useAudioRecorder()
  const localRecording = useLocalRecording()

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Confirm discard</ModalHeader>
        <ModalCloseButton />
        <ModalBody>Are you sure you want to discard this recording?</ModalBody>
        <ModalFooter>
          <Button
            rounded={'1.25rem'}
            colorScheme={'red'}
            onClick={async () => {
              await discardExistingRecording()
              localRecording.refetch()
              onClose()
            }}
            mr={3}
          >
            Discard
          </Button>
          <Button
            onClick={onClose}
            rounded={'1.25rem'}
            variant="brand-solid-white"
          >
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
